import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ButtonLargeWeb } from "../../../../../components/ButtonLargeWeb";
import { NavigationButton } from "../../../../../components/NavigationButton";
import { StepperInglesLargo } from "../../../../../components/StepperInglesLargo";
import useDynamicColors from "../../../../../hooks/useDynamicColors";

import "./style.css";

export const CorporativoBusinessBankingDocumentIdWeb = ({
  countries = [],
  onSelectCountry,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/business_banking-credentials-corporativo-web${currentParams}`);
  };

  const colors = useDynamicColors();
  const boxes = Array(6).fill("");

  const laptop = {
    marginTop: "30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#333",
    borderRadius: "15px 15px 5px 5px",
    padding: "17px",
    width: "1400px",
    height: "800px",
    position: "relative",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  };

  const screen = {
    backgroundColor: "white",
    borderRadius: "5px",
    overflowY: "scroll",
    overflowX: "hidden",
    width: "100%",
    height: "800px",
  };

  const container = {
    display: "flex",
    height: "100vh",
  };

  const base = {
    position: "absolute",
    width: "1600px",
    height: "20px",
    backgroundColor: "rgb(170, 170, 170)",
    borderRadius: "0px 0px 10px 10px",
    bottom: 0,
  };

  return (
    <div style={laptop}>
      <div style={screen}>
        <div style={container}>
          <div className="corporativo-business-document-id">
            <div className="div-2">
              <div className="group-wrapper">
                <div className="div-wrapper-mail-code">
                  <div className="frame-wrapper">
                    <div className="frame-2">
                      <div className="frame-3">
                        <div className="group-2">
                          <div className="group-3">
                            <div className="frame-4">
                              <div className="text-wrapper-2">
                                Identity validation
                              </div>

                              <p className="subtitle">
                                <span className="span">
                                  Take a picture of your document
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="document-instructions">
                        <p className="instructions-text">
                          We will take a picture of the front and back. Center
                          your document in the frame and make sure there is no
                          glare or shadows. The photos will be captured
                          automatically.
                        </p>

                        <div className="image-wrapper">
                          <img
                            src="/img/card_id.png"
                            width={150}
                            height={150}
                            alt="Document Capture Illustration"
                            className="illustration"
                          />
                        </div>

                        <div className="select-wrapper">
                          <label htmlFor="country-select">Country</label>
                          <select
                            id="country-select"
                            // value={selectedCountry}
                            onChange={(e) => onSelectCountry(e.target.value)}
                          >
                            <option value="">Select Country</option>
                            {countries.map((country, index) => (
                              <option value={country} key={index}>
                                {country}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="frame-5">
                        <div className="text-4">Continue later</div>
                        <div onClick={handleButtonClick}>
                          <ButtonLargeWeb
                            className="button-large-WEB-instance"
                            iconLeft={false}
                            iconRigth={false}
                            primarioActive
                            primarioInactive={false}
                            secundarioActive={false}
                            secundarioInactive={false}
                            terciarioActive={false}
                            terciarioInactive={false}
                            text="Take photos"
                            textClassName="button-large-WEB-2"
                          />
                        </div>
                      </div>

                      <div className="frame-6" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="component-7">
                {colors.url_logo !== "" && (
                  <img width={30} height="auto" src={colors.url_logo} />
                )}
                <div className="language">
                  <img
                    src="https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us"
                    height={30}
                    width={30}
                  />
                </div>
              </div>

              <div className="group-4">
                <div className="frame-7">
                  © 2025 All rights reserved
                  <img width={100} height="auto" src="/img/veritran.svg" />
                  Innovation Lab
                </div>
              </div>

              <div className="frame-8">
                <div className="frame-9">
                  <NavigationButton
                    className="nav-button-left"
                    defaultMasterButtonNavDivClassName="navigation-button-instance"
                    focus={false}
                    platform="web-react"
                    state="default"
                    theme="light"
                    type="back"
                  />
                  <div className="text-wrapper-4">
                    Account opening application
                  </div>
                </div>

                <div className="group-5">
                  <div className="group-6">
                    <div className="group-7">
                      <div className="stepper-ingles-largo-wrapper">
                        <StepperInglesLargo
                          prendidoHasta={5}
                          className="stepper-ingles-largo-instance"
                          prendido="two"
                          property2="two"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={base}></div>
    </div>
  );
};
